import { render } from "./CodeAuthority.vue?vue&type=template&id=c27f891a&scoped=true"
import script from "./CodeAuthority.vue?vue&type=script&lang=js"
export * from "./CodeAuthority.vue?vue&type=script&lang=js"

import "./CodeAuthority.vue?vue&type=style&index=0&id=c27f891a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27f891a"]])

export default __exports__